var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1216,
    height: 1409,
    viewBox: "0 0 1216 1409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M894.289 1168.29C1154.95 933.974 1250.21 979.496 1204.48 633.012C1187.98 508.012 893.484 465.583 962.484 377.514C1076.48 232.012 1147.88 224.933 1131.98 118.013C1073.33 -117.624 748.48 42.5117 571.98 225.512C395.48 408.512 -150.15 172.401 39.4805 464.012C167.484 660.854 250.48 724.698 167.484 806.014C-10.6616 980.552 -65.5453 1072.12 115.484 1196.51C435.318 1410.5 616.146 1550.4 892.845 1169.89C893.257 1169.33 893.768 1168.76 894.289 1168.29Z",
    fill: "#ECF8FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBlob);
export default __webpack_public_path__ + "static/media/blue-blob.84194cb7a1e2f0bddabb4f9fb9849954.svg";
export { ForwardRef as ReactComponent };